<template>
  <v-main :anchor-layout="layoutName">
    <v-navigation-drawer
      app clipped dark
      class="d-print-none"
      v-model="showNavigation"
    >
      <adminNavigation
        v-if="applicationLoaded"
      ></adminNavigation>
    </v-navigation-drawer>

    <v-app-bar app fixed clipped-left dark class="d-print-none">
      <v-app-bar-nav-icon @click.stop="toggleNavigation"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="d-flex pa-2 align-center">
        <v-img width="25" height="25" lazy-src :src="tinyLogoUrl"></v-img>

        <span class="pa-2">{{siteName}}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-container
      v-if="isUser && applicationLoaded"
      :fluid="fullScreen"
    >
      <breadcrumb></breadcrumb>
      <div anchor-router-view-container>
        <router-view></router-view>
      </div>
    </v-container>
  </v-main>
</template>

<script lang="babel" type="text/babel">
import adminNavigation from 'layouts/admin/adminNavigation.vue'
import layoutMixin from 'layouts/layoutMixin.js'
import Vue from 'vue'
export default {
  mixins: [layoutMixin],
  data() {
    return {
      showNavigation: false,
      layoutName: 'admin',
    }
  },
  created() {
    this.$ssr()
    this.showNavigation = !this.$isMobileDetectWindowWidth ? true : false
    this.setupLayout()
    this.checkIdentity()
  },
  methods: {
    checkIdentity() {
      if(this.isUser) return
      this.$router.replace({
        name: 'admin.login',
        query: {
          path: this.$route.fullPath,
        }
      })
    },
    toggleNavigation() {
      this.showNavigation = !this.showNavigation
      this.$nextTick(() => {
        this.$root.$emit('onPageResize')
      })
    },
  },
  watch: {
    isUser() {
      this.checkIdentity()
    },
    fullScreen() {
      setTimeout(() => this.showNavigation = !this.fullScreen, 1000)
    },
  },
  computed: {
    fullScreen() {
      return this.$store.getters['base/fullScreen']
    },
    siteName() {
      return this.$store.getters['base/siteName']
    },
    tinyLogoUrl() {
      return this.$store.getters['base/tinyLogoUrl']
    },
  },
  components: {
    adminNavigation,
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>